import csrfToken from '@cta/shared/csrf';

export default async function logoutAndRedirect(logoutPath) {
  const response = await fetch(logoutPath, {
    method: 'delete',
    headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
  });

  const json = await response.json();
  document.location = json.redirectPath;
}
